import { createServiceManifest } from '@estee/elc-service';
import { VTO, VTO_CTA_BUTTON, VTO_SKIN_CARE } from '@estee/elc-service-view-names';
import { VtoService } from './service-setup/VtoService';
import { serviceQueries as queries } from '@estee/elc-service-bus';

const { name, version } = __serviceInfo__;

const serviceViews = [VTO, VTO_CTA_BUTTON, VTO_SKIN_CARE];
const serviceEvents: string[] = [];
const serviceQueries: string[] = [queries.GET_BEST_MATCH_SKU_ID];

export const ServiceManifest = createServiceManifest<VtoService>(
    {
        views: serviceViews,
        events: serviceEvents,
        queries: serviceQueries,
        name,
        version
    },
    () =>
        import(
            /* webpackChunkName: 'core' */
            './service-setup/diContainer'
        ),
    'vtoService'
);
